<div class="pageContainer">
    <mat-nav-list id="home-item-list" class="body-top">
        <!--  -->
        <mat-list-item
            *ngFor="let item of menuItem"
            class="list-item"
            [routerLink]="item.routingLink"
        >
            <a matLine class="list-icon-text">
                <span class="list-icon">
                    <img [src]="item.imgSrc" alt="" class="item-icon" />
                </span>
                <span class="list-text">
                    {{ item.name | translate }}
                </span>
            </a>
            <button mat-icon-button class="list-arrow">
                <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
        </mat-list-item>
    </mat-nav-list>
</div>
